import * as routesTitles from '@/configs/translates.config';

export default {
	pages: {
		dashboard: routesTitles.dashboard.en.plural,
		'file-manager': routesTitles.fileManager.en.plural,
		sets: routesTitles.sets.en.plural,
		categories: routesTitles.categories.en.plural,
		news: routesTitles.news.en.plural,
		services: routesTitles.services.en.plural,
		filters: routesTitles.filters.en.plural,
		keywords: routesTitles.keywords.en.plural,
		publishers: routesTitles.publishers.en.plural,
		sellers: routesTitles.sellers.en.plural,
		products: routesTitles.products.en.plural,
		orders: routesTitles.orders.en.plural,
		'loyalty-points': routesTitles.loyaltyPoints.en.plural,
		plans: routesTitles.plans.en.plural,
		coupons: routesTitles.coupons.en.plural,
		offers: routesTitles.offers.en.plural,
		albums: routesTitles.albums.en.plural,
		videos: routesTitles.videos.en.plural,
		users: routesTitles.users.en.plural,
		'affiliate-marketers': routesTitles.affiliateMarketers.en.plural,
		'system-users-roles': routesTitles.systemUsersRoles.en.plural,
		'system-users': routesTitles.systemUsers.en.plural,
		branches: routesTitles.branches.en.plural,
		sliders: routesTitles.sliders.en.plural,
		subscriptions: routesTitles.subscriptions.en.plural,
		'about-us': routesTitles.aboutUs.en.plural,
		'company-values': routesTitles.companyValues.en.plural,
		'company-histories': routesTitles.companyHistories.en.plural,
		seo: routesTitles.SEO.en.plural,
	}
}